<template>
    <div class="vue-menu-mobile">
        <div class="nav-menu__toggle" @click="onOpenMenu" :class="{'nav-menu__toggle_text-center': !bigMenu}">
            <svg class="menu-mobile__squares"><use xlink:href="#svg-squares"></use></svg>
            <span>{{ messages.catalogTitle }}</span>
        </div>
<!--        <div-->
<!--            v-if="isMenuActive"-->
<!--            v-on:click="onCloseMenu"-->
<!--            class="nav-menu__overlay" />-->
        <div
            class="nav-menu__container"
            :class="{ isOpened: isMenuActive }"
            ref="mobileMenu"
        >
            <div class="nav-menu__header">
                <div class="nav-menu__back">
                    <span @click="onCloseMenu">
                        <svg><use xlink:href="#svg-menu-back"></use></svg>
                    </span>
                    <div class="title">{{ messages.catalogTitle }}</div>
                </div>

                <svg @click="onCloseMenu"  class="nav-menu__close">
                    <use data-v-a789cf38="" xlink:href="#svg-close"></use>
                </svg>
            </div>
            <ul class="nav-menu__list nav-menu__scroll">
                <li
                    v-for="item in menuObj"
                    :class="{ hasSubMenu: item.items }"
                    class="nav-menu__lvl1"
                >
                    <a @click="onOpenSubMenu(item, $event)" :href="item.href">{{item.name}}</a>
                    <i @click="onOpenSubMenu(item, $event)" v-if="item.items" class="love-arrowIcon" />
                </li>
            </ul>
        </div>

        <div
            class="nav-menu__container sub-menu"
            :class="{ isOpened: isSubMenuActive }"
            ref="mobileSubMenu"
            v-if="subMenuData"
        >
            <div class="nav-menu__header">
                <div class="nav-menu__back">
                    <span @click="onCloseSubMenu">
                        <svg><use xlink:href="#svg-menu-back"></use></svg>
                    </span>
                    <div class="title">
                        {{subMenuData.name}}
                    </div>
                </div>

                <svg @click="onCloseSubMenu"  class="nav-menu__close">
                    <use data-v-a789cf38="" xlink:href="#svg-close"></use>
                </svg>
<!--                <i class="love-closeIcon" v-on:click="onCloseSubMenu" />-->
            </div>
            <div class="nav-menu__scroll">
                <ul  v-for="(subItem, i) in subMenuData.items" class="nav-menu__list">
                    <a v-if="i === 0" :href="subMenuData.link" class="nav-menu__main-link">
                        {{ messages.all }} {{ subMenuData.name.toLowerCase() }}
                    </a>
                    <li v-if="subItem.name" class="title">
                        <a :href="subItem.href" v-html="subItem.name"></a>
                    </li>
                    <li v-for="item in subItem.items">
                        <a v-if="item.href && item.name" :href="item.href" v-html="item.name"></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            menuObj: {type: Array},
            bigMenu: {},
            messages: {
                type: Object,
                default() {
                    return {
                        'catalogTitle': 'каталог прикрас (Нужен текст)',
                        all: 'Всі'
                    }
                }
            },
        },
        name: 'vue-menu-mobile',
        data() {
            return {
                isMenuActive: false,
                isSubMenuActive: false,
                subMenuData: [],
                subMenuTitle: ''
            }
        },
        methods: {
            onOpenMenu() {
                this.isMenuActive = true;
                this.$emit('open-menu', this.isMenuActive);
            },
            onCloseMenu() {
                if (this.isSubMenuActive) {
                    this.isSubMenuActive = false
                } else {
                    this.isMenuActive = false;
                }
                this.$emit('open-menu', this.isMenuActive);
            },
            onOpenSubMenu({ name, items }, e) {
                if (items) {
                    e.preventDefault();
                    this.isSubMenuActive = true;
                    this.subMenuData = { name, items };
                    this.menuObj.forEach(el => {
                        if (el.name === name) {

                            this.subMenuData = {...this.subMenuData, link: el.href,};
                        }
                    })

                }
            },
            onCloseSubMenu() {
                this.isSubMenuActive = false;
            }
        },
        watch: {
            isMenuActive(val) {
                // console.log(val, !this.bigMenu)
                if (!this.bigMenu) {
                    if (val) {
                        document.body.classList.add('overflow');
                    } else {
                        document.body.classList.remove('overflow');
                    }
                }
            }
        },
        mounted() {
            if (App.debug) {
                console.log('Component: vue-menu-mobile', this);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .vue-menu-mobile{
        margin-right: 14px;
        display: flex;
        align-items: center;
        width: 100%;

        .nav-menu {
            &__toggle {
                display: flex;
                font-weight: 400;
                font-size: rem(16);
                text-transform: uppercase;
                padding: 15px 0;
                width: 100%;
                svg {
                    width: 12px;
                    height: 12px;
                    margin-right: 8px;
                    //transform: translateY(-2px);
                }
                &_text-center{
                    text-align: center;
                    justify-content: center;
                }
            }
            &__close{
                width: 16px;
                height: 16px;
                margin-right: 24px;
                flex-shrink: 0;
            }
            &__container {
                height: 100%;
                width: calc(100vw - 65px);
                //position: absolute;
                position: fixed;
                top: 0;
                //right: 100%;
                left: -100%;
                bottom: 0;
                background-color: var(--background-color-thirternary);
                z-index: 100;
                overflow-y: hidden;
                @include prefix(transition, .3s ease-in);

                &.isOpened {
                    //right: 0px;
                  left: 0;
                    @include prefix(animation, fadein .7s);
                }

                &.sub-menu {
                    z-index: 101;

                    li.title {
                        color: var(--text-colour-secondary);
                        font-weight: 500;
                        font-size: rem(10);
                        line-height: 100%;
                        letter-spacing: 0.1em;
                        text-transform: uppercase;
                    }
                }
            }
            &__scroll{
                overflow-y: auto;
                max-height: calc(100% - 58px);
                //padding-top: 24px;

            }
            &__list {
                padding: 16px 24px 0;
                &:first-child{
                    padding: 24px 24px 0;
                }
                > li {
                    margin-bottom: 15px;
                    > a {
                        display: inline-block;
                        width: 100%;
                    }

                    &.hasSubMenu {
                        vertical-align: middle;
                        display: flex;
                        align-items: center;
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }
            }

            &__main-link{
                display: block;
                font-weight: 500;
                font-size: rem(14);
                line-height: 100%;
                color: #191918;
                margin-bottom: 24px;
            }

            &__header {
                position: relative;
                min-height: 56px;
                vertical-align: middle;
                display: flex;
                align-items: center;
                flex-direction: row;
                justify-content: space-between;
                background-color: var(--background-colour-secondary);
                box-shadow: var(--box-shadow-primary-small);
                padding-left: 16px;
                .title {
                    padding: 0 26px 0 8px;
                    font-size: rem(14);
                    font-weight: 500;
                    transform: translateY(2px);
                    letter-spacing: 0.08em;
                    text-transform: uppercase;
                }
            }
            &__lvl1{
                margin-bottom: 24px;
                a{
                    font-weight: 500;
                    font-size: rem(14);
                    line-height: 100%;
                    color: var(--text-colour-primary);
                }
                i{
                    transform: translateY(-1px);
                }
            }
            &__back{
                display: flex;
                align-items: center;
                svg{
                    display: block;
                    width: 16px;
                    height: 16px;
                    //transform: translateY(-2px);
                }
            }
        }
    }
    .menu-mobile{
        &__squares{
            transform: translateY(-1px);
        }
    }
</style>